import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    root:{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 5555,
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 12px 32px rgba(0, 0, 0, 0.28)',
    },
    move:{
        userSelect: 'none'
    }
}
